import PlayerPerformanceActionType from './playerPerformanceActionType';

export const changeTransactionLoadingState = (state) => ({
  type: PlayerPerformanceActionType.CHANGE_TRANSACTION_LOADING_STATE,
  payload: state,
});

export const getPlayersAggregations = (params) => ({
  type: PlayerPerformanceActionType.GET_PLAYERS_AGGREGATIONS,
  payload: { params },
});

export const savePlayersAggregations = (data) => ({
  type: PlayerPerformanceActionType.SAVE_PLAYERS_AGGREGATIONS,
  payload: { data },
});

export const resetPlayersAggregations = () => ({
  type: PlayerPerformanceActionType.RESET_PLAYERS_AGGREGATIONS,
});

export const generatePlayersAggregationsReport = (params) => ({
  type: PlayerPerformanceActionType.GENERATE_PLAYERS_AGGREGATIONS_REPORT,
  payload: { params },
});
